import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import "./style.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { logo } from '../../Assets/images';
import { base_url } from '../../Api/apiConfig';


const Thankyou = () => {
    const navigate = useNavigate()

    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const queryParams = new URLSearchParams(location.search);
    const paramValue = queryParams.get("verification-code");


    const codeData = async () => {
        setLoading(true);
        setError(false);
        setLoading(true)
        try {
            const response = await fetch(`${base_url}/verify-email-with-code`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "verification_code": paramValue
                })
            });



            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();
            console.log('abc', result);
            setLoading(false);
            if (result?.status) {
                navigate('/login', { state: { verified: true }, replace: true });
            } else {
                setError(true);
            }

        } catch (err) {
            console.log(err);
            setLoading(false);
            setError(true);
        }
    };


    useEffect(() => {
        if (paramValue != "") {
            codeData()
        }
    }, [paramValue])


    useEffect(() => {
        document.title = 'Kvr User | Verification Page';
    }, [])




    return (
        <>
            <div className='verificationModule h-100vh d-flex pt-5 mt-5'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="m-auto siteLogo text-center w-100">
                                <img src={logo} className="mw-100" />
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className='moduleData text-center'>

                                {
                                    loading && (
                                        <h1>Verifying your identity...</h1>
                                    )
                                }

                                {
                                    error && (
                                        <>
                                            <FontAwesomeIcon icon={faTimesCircle} className='text-danger'></FontAwesomeIcon>
                                            <h3>Verification Error, Please try again.</h3>
                                        </>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default Thankyou
